import React from 'react';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { EVALUATION_TEXT } from './lang';
import { TextField, Button } from '../../../../../components';

type ScholarshipCommentProps = {
  isFullWidth: boolean;
  question: React.ReactNode;
  comment: string;
  enableEdit: boolean;
  savedAt: string;
  lengthLimit: number;
  handleOpenEgDialog: () => void;
  handleOpenEditHistory: () => void;
  handleSaveComment: (comment: string) => void;
};

export const ScholarshipComment: React.FC<ScholarshipCommentProps> = (
  props: ScholarshipCommentProps,
) => {
  const {
    isFullWidth,
    question,
    comment,
    lengthLimit,
    enableEdit,
    savedAt,
    handleOpenEgDialog,
    handleOpenEditHistory,
    handleSaveComment,
  } = props;

  const formik = useFormik({
    initialValues: {
      comment,
    },
    validationSchema: object().shape({
      comment: string().test(
        'byte-length',
        `Exceeds maximum length of ${lengthLimit} characters`,
        (value?: string) => {
          return String(value).length <= lengthLimit;
        },
      ),
    }),
    onSubmit: values => {
      handleSaveComment(values.comment);
    },
  });

  return (
    <form
      className={`${isFullWidth ? 'col-span-2' : ''} p-4 bg-[#ECECEC] flex flex-col justify-between`}
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className="w-full">
        <div className="font-medium">{question}</div>
        <div className="text-sm">
          <span>{EVALUATION_TEXT.WRITING_COMMENTS}</span>
          <span
            className="underline text-[#255CFF] cursor-pointer"
            onClick={handleOpenEgDialog}
          >
            {EVALUATION_TEXT.COMMENT_EG}
          </span>
        </div>
      </div>
      <div className="w-full py-2">
        <TextField
          value={formik.values.comment}
          fullWidth
          rows={10}
          multiline
          sx={{
            '.MuiInputBase-root': {
              ...(enableEdit && { background: '#ffffff' }),
            },
          }}
          disabled={!enableEdit}
          name="comment"
          error={formik.touched.comment && Boolean(formik.errors.comment)}
          helperText={Boolean(formik.touched.comment) && formik.errors.comment}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        <div className="w-full mt-2 px-2 flex flex-row justify-between">
          <h2
            className="underline text-[#255CFF] cursor-pointer text-sm"
            onClick={handleOpenEditHistory}
          >
            {EVALUATION_TEXT.EDIT_HISTORY}
          </h2>
          <h2 className="flex flex-col text-sm text-gray-400">
            <div className="flex flex-row-reverse mb-2">
              <Button
                size="small"
                variant="contained"
                disabled={!enableEdit}
                type="submit"
                sx={{
                  textTransform: 'none',
                }}
              >
                {EVALUATION_TEXT.SAVE}
              </Button>
            </div>
            {savedAt}
          </h2>
        </div>
      </div>
    </form>
  );
};
